import { Container, Section, P, CompliancyRequirements } from "../components/common-components";
import { FormHeader } from "../components/FormHeader";
import { FormFooter } from "../components/FormFooter";
import { ServiceInfo } from "../components/ServiceInfo";
import { EligibilityInformation } from "../components/EligibilityInformation";
import { PatientInformation } from "../components/PatientInformation";
import { PatientContactInformation } from "../components/PatientContactInformation";
import { AlternateCaregiverInformation } from "../components/AlternateCaregiverInformation";
import { PrimaryHealthcareProvider } from "../components/PrimaryHealthcareProvider";
import { ClinicalServiceType } from "../components/ClinicalServiceType";
import { ConsentInformation } from "../components/ConsentInformation";
import { PreAssessmentSpecialPopulations } from "../components/PreAssessmentSpecialPopulations";
import { AllergyInformation } from "../components/AllergyInformation";
// import { LifestyleFactors } from "../components/LifestyleFactors";
import { Symptoms } from "../components/Symptoms";
import { MedicalHistorySection } from "../components/MedicalHistorySection";
import { Interventions } from "../components/Interventions";
import { ClassificationofMinorAilment } from "../components/ClassificationofMinorAilment";
import { TreatmentInformation } from "../components/TreatmentInformation";
import { EducationalInformation } from "../components/EducationalInformation";
import { ReferralsAndNotifications } from "../components/ReferralsAndNotifications";
import { PrescribingPharmacistInformation } from "../components/PrescribingPharmacistInformation";
import { PharmacyInformation } from "../components/PharmacyInformation";
import { InsuranceInformation } from "../components/InsuranceInformation";
import { TreatmentPlan } from "../components/TreatmentPlan";
import { FollowUpAppointments } from "../components/FollowUpAppointments";
import { PharmacistMonitoringPlans } from "../components/PharmacistMonitoringPlans";
import { BillingInformation } from "../components/BillingInformation";
import { useContext, useEffect } from "react";
import { FormContextMA } from "../form-context";

export const InitialAssessmentForm = () => {
  const {
    documentation,
    treatment,
    preAssessment,
    clinicalAssessment,
    signsAndSymptoms,
    differentialAssessment,
    education,
    formType,clinicalServiceName, patient, startDateTime, endDateTime
  } = useContext(FormContextMA);
  const { serviceId } = useContext(FormContextMA);

  const endServiceObj = {
    ageAlertEndService: preAssessment?.ageAlertConfirmationType === 4,
    pregnancyEndService:
      preAssessment?.ageAlertConfirmationType === 4 ||
      preAssessment?.pregnancyAlertConfirmationType === 4,
    redFlagEndService:
      preAssessment?.ageAlertConfirmationType === 4 ||
      preAssessment?.pregnancyAlertConfirmationType === 4 ||
      clinicalAssessment?.redFlagConfirmationType === 4,
    drugInducedEndService:
      preAssessment?.ageAlertConfirmationType === 4 ||
      preAssessment?.pregnancyAlertConfirmationType === 4 ||
      clinicalAssessment?.redFlagConfirmationType === 4 ||
      clinicalAssessment?.drugInducedConfirmationType === 4,
    nonTypicalEndService:
      preAssessment?.ageAlertConfirmationType === 4 ||
      preAssessment?.pregnancyAlertConfirmationType === 4 ||
      clinicalAssessment?.redFlagConfirmationType === 4 ||
      clinicalAssessment?.drugInducedConfirmationType === 4 ||
      signsAndSymptoms?.nonTypicalConfirmationType === 4,
    typicalEndService:
      preAssessment?.ageAlertConfirmationType === 4 ||
      preAssessment?.pregnancyAlertConfirmationType === 4 ||
      clinicalAssessment?.redFlagConfirmationType === 4 ||
      clinicalAssessment?.drugInducedConfirmationType === 4 ||
      signsAndSymptoms?.nonTypicalConfirmationType === 4 ||
      signsAndSymptoms?.typicalConfirmationType === 4,
    allergensEndService:
      preAssessment?.ageAlertConfirmationType === 4 ||
      preAssessment?.pregnancyAlertConfirmationType === 4 ||
      clinicalAssessment?.redFlagConfirmationType === 4 ||
      clinicalAssessment?.drugInducedConfirmationType === 4 ||
      signsAndSymptoms?.nonTypicalConfirmationType === 4 ||
      signsAndSymptoms?.typicalConfirmationType === 4 ||
      signsAndSymptoms?.allergensConfirmationType === 4,
    infectiveEndService:
      preAssessment?.ageAlertConfirmationType === 4 ||
      preAssessment?.pregnancyAlertConfirmationType === 4 ||
      clinicalAssessment?.redFlagConfirmationType === 4 ||
      clinicalAssessment?.drugInducedConfirmationType === 4 ||
      signsAndSymptoms?.nonTypicalConfirmationType === 4 ||
      signsAndSymptoms?.typicalConfirmationType === 4 ||
      signsAndSymptoms?.allergensConfirmationType === 4 ||
      signsAndSymptoms?.infectiveConfirmationType === 4,
    differentialEndService:
      preAssessment?.ageAlertConfirmationType === 4 ||
      preAssessment?.pregnancyAlertConfirmationType === 4 ||
      clinicalAssessment?.redFlagConfirmationType === 4 ||
      clinicalAssessment?.drugInducedConfirmationType === 4 ||
      signsAndSymptoms?.nonTypicalConfirmationType === 4 ||
      signsAndSymptoms?.typicalConfirmationType === 4 ||
      signsAndSymptoms?.allergensConfirmationType === 4 ||
      signsAndSymptoms?.infectiveConfirmationType === 4 ||
      differentialAssessment?.differentialConfirmationType === 4,
    pharmacologicalHistoryEndService:
      preAssessment?.ageAlertConfirmationType === 4 ||
      preAssessment?.pregnancyAlertConfirmationType === 4 ||
      clinicalAssessment?.redFlagConfirmationType === 4 ||
      clinicalAssessment?.drugInducedConfirmationType === 4 ||
      signsAndSymptoms?.nonTypicalConfirmationType === 4 ||
      signsAndSymptoms?.typicalConfirmationType === 4 ||
      signsAndSymptoms?.allergensConfirmationType === 4 ||
      signsAndSymptoms?.infectiveConfirmationType === 4 ||
      differentialAssessment?.differentialConfirmationType === 4 ||
      treatment?.pharmacologicalHistoryConfirmationType === 4,
    pharmacologicalEndService:
      preAssessment?.ageAlertConfirmationType === 4 ||
      preAssessment?.pregnancyAlertConfirmationType === 4 ||
      clinicalAssessment?.redFlagConfirmationType === 4 ||
      clinicalAssessment?.drugInducedConfirmationType === 4 ||
      signsAndSymptoms?.nonTypicalConfirmationType === 4 ||
      signsAndSymptoms?.typicalConfirmationType === 4 ||
      signsAndSymptoms?.allergensConfirmationType === 4 ||
      signsAndSymptoms?.infectiveConfirmationType === 4 ||
      differentialAssessment?.differentialConfirmationType === 4 ||
      treatment?.pharmacologicalHistoryConfirmationType === 4 ||
      treatment?.pharmacologicalConfirmationType === 4,
  };

  return (
    <Container>
      <FormHeader formType = {formType} />
      <div className="space-y-[0.166667in] mx-[0.375in] mt-[0.25in]">
        <ServiceInfo 
                  referral = {null} 
                  isReferral = {false} 
                  formType = {formType}
                  clinicalServiceName = {clinicalServiceName}
                  patient = {patient}
                  startDateTime = {startDateTime} />
        <EligibilityInformation  formType = {formType}/>
        <PatientInformation  formType = {formType} patient = {patient} preAssessment = {preAssessment}/>
        <InsuranceInformation  formType = {formType} patient = {patient}/>
        <PatientContactInformation  formType = {formType} patient = {patient}/>
        <AlternateCaregiverInformation formType = {formType} patient = {patient} />
        <PrimaryHealthcareProvider  formType = {formType}  patient = {patient}/>
        <ClinicalServiceType  formType = {formType} patient={patient} preAssessment={ preAssessment} />
        <ConsentInformation formType = {formType} patient={patient} preAssessment = { preAssessment} startDateTime={startDateTime}/>
        <CompliancyRequirements formType={formType} pharmacyName="[name of pharmacy]" />
        <PreAssessmentSpecialPopulations formType = {formType} preAssessment={ preAssessment}/>
        <AllergyInformation formType = {formType} patient={patient} clinicalAssessment = { clinicalAssessment}/>
        {/* <LifestyleFactors formType = {formType} clinicalAssessment = {clinicalAssessment} /> */}
        {!endServiceObj.drugInducedEndService && <Symptoms formType={formType} clinicalServiceName={clinicalServiceName} 
        preAssessment={preAssessment} signsAndSymptoms={signsAndSymptoms}/>}
        {!endServiceObj.pregnancyEndService && <MedicalHistorySection endServiceObj={endServiceObj} formType={formType} clinicalAssessment= {clinicalAssessment}
         signsAndSymptoms={signsAndSymptoms} differentialAssessment={differentialAssessment} />}
        <Interventions formType = {formType}/>
        {!endServiceObj.differentialEndService && <ClassificationofMinorAilment clinicalServiceName={clinicalServiceName} treatment={treatment} formType = {formType} />}
        {!endServiceObj.differentialEndService && <TreatmentInformation formType = {formType} treatment = {treatment} />}
        {!endServiceObj.differentialEndService && <TreatmentPlan endServiceObj={endServiceObj} clinicalServiceName={clinicalServiceName} treatment={treatment} formType={formType}/>}
        {!endServiceObj.pharmacologicalEndService && <EducationalInformation />}
        {!endServiceObj.pharmacologicalEndService && <FollowUpAppointments education={education} formType={formType} clinicalServiceName={clinicalServiceName} serviceId={serviceId} />}
        <PharmacistMonitoringPlans formType={formType}/>
        <ReferralsAndNotifications formType={formType} documentation ={documentation} />
        <BillingInformation documentation={documentation} treatment={treatment} formType={formType} />
        <PrescribingPharmacistInformation formType ={formType} startDateTime={startDateTime} endDateTime={endDateTime} />
        <PharmacyInformation formType = {formType}/>
      </div>
      <FormFooter />
    </Container>
  );
};
